import { render } from "./SelectionTextCard.vue?vue&type=template&id=f13b5ab4"
import script from "./SelectionTextCard.vue?vue&type=script&lang=js"
export * from "./SelectionTextCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__